import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { RewardInfoProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import InstructionsSlideTwo from '../assets/videos/InstructionsSlideTwo.mp4';
import { GiftBox } from '../Icons/GiftBox';
import { GiftCard } from '../Icons/GiftCard';
import { Ribbon } from '../Icons/Ribbon';
import ReactPlayer from 'react-player';
import { RewardInfoModal } from '../content';

const RewardInfo = ({ leftItems, collectedItems, activeLocale, active, setActive }: RewardInfoProps) => {
  const getItemLeftLine = (leftItems: number) => {
    if (leftItems === 3) {
      return activeLocale === undefined || !((activeLocale as keyof typeof RewardInfoModal) in RewardInfoModal)
        ? RewardInfoModal['en'].thirdItem
        : RewardInfoModal[activeLocale as keyof typeof RewardInfoModal].thirdItem;
    } else if (leftItems === 2) {
      return activeLocale === undefined || !((activeLocale as keyof typeof RewardInfoModal) in RewardInfoModal)
        ? RewardInfoModal['en'].twoItem
        : RewardInfoModal[activeLocale as keyof typeof RewardInfoModal].twoItem;
    } else if (leftItems === 1) {
      return activeLocale === undefined || !((activeLocale as keyof typeof RewardInfoModal) in RewardInfoModal)
        ? RewardInfoModal['en'].oneItem
        : RewardInfoModal[activeLocale as keyof typeof RewardInfoModal].oneItem;
    }
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '350px', '400px', '400px', '450px']}
        height={['380px', '460px', '500px', '500px', '550px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <Box
            width={['100%', '100%', '100%', '100%', '100%']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'column', 'column']}
            position="relative"
          >
            <Box
              className="instructions-slider"
              width={['100%', '100%', '100%', '100%', '100%']}
              h={['180px', '230px', 'auto', 'auto', 'auto']}
              textAlign="center"
            >
              <ReactPlayer
                id="instructions-screen-video"
                height="100%"
                width="100%"
                loop={true}
                muted
                controls={false}
                playing={true}
                url={InstructionsSlideTwo}
                playsinline
              />
            </Box>
          </Box>

          <Text
            w={['170px', '250px', '250px', '250px', '250px']}
            textAlign="center"
            fontSize={['15px', '18px', '20px', '20px', '20px']}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof RewardInfoModal) in RewardInfoModal)
              ? RewardInfoModal['en'].textOne
              : RewardInfoModal[activeLocale as keyof typeof RewardInfoModal].textOne}
          </Text>

          <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            <Text
              textAlign="center"
              fontSize={['12px', '13px', '15px', '15px', '15px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayItalic'}
            >
              {getItemLeftLine(leftItems)}
            </Text>
            <Box
              backgroundColor="white"
              boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.25)"
              w={['110px', '130px', '140px', '140px', '140px']}
              mt={['5px']}
              mb={['10vw', '30px', '40px', '40px']}
              p={['5px 15px']}
              borderRadius="30px"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <GiftCard
                boxSize={[5, 6, 6, 6]}
                cursor="pointer"
                transition="0.5s"
                fill={collectedItems.giftcard ? '#FFCB00' : 'white'}
              />
              <Ribbon
                boxSize={[5, 6, 6, 6]}
                cursor="pointer"
                transition="0.5s"
                fill={collectedItems.ribbon ? '#FFCB00' : 'white'}
              />
              <GiftBox
                boxSize={[5, 6, 6, 6]}
                cursor="pointer"
                transition="0.5s"
                fill={collectedItems.giftbox ? '#FFCB00' : 'white'}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default RewardInfo;
